<template>
  <div>
    <el-table
      :border="true"
      id="rebateSetTable"
      :data="tableData"
      ref="table"
      show-summary
      :header-cell-style="{ background: '#f5f7fa' }"
      :max-height="tableHeight"
      @sort-change="handlerSortChange"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-table-column
        v-for="item in columns"
        :prop="item.key"
        :label="item.name"
        :key="item.name"
        :sortable="item.sort ? 'custom' : false"
        :fixed="item.fixed"
        align="center"
        :width="item.width"
      >
        <el-table-column
          :prop="item.key"
          :label="totalObj[item.key] ? totalObj[item.key] + '' : ''"
          :width="item.width"
          :key="item.name"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ String(scope.row[item.key]) }} </span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div class="page-wrap">
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changeSize"
      ></self-pagination>
    </div>
  </div>
</template>

<script>
import { columns, osTypeFu } from "./config";
import { getAllReportListFetch } from "@/api/api";
import { downLoadWrokSheet } from "@/utils/commonTools";

export default {
  data() {
    return {
      columns,
      tableHeight: window.innerHeight - 290,
      tableData: [],
      totalObj: {},
      loading: false,
      filterParams: {},
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      sortInfo: {
        sortField: "",
        sortValue: null,
      },
    };
  },
  computed: {},
  props: {},
  methods: {
    handleSearch(filterParams) {
      this.filterParams = filterParams;
      this.pageData.page = 1;
      this.getList();
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changeSize(size) {
      this.pageData.size = size;
      this.getList();
    },
    handlerSortChange(data) {
      const { prop, order } = data;
      this.sortInfo = {
        sortField: prop,
        sortValue: order == null ? null : order == "descending" ? 1 : 2,
      };
      this.getList();
    },
    getList() {
      this.loading = true;
      getAllReportListFetch({
        ...this.filterParams,
        page: this.pageData.page,
        size: this.pageData.size,
        ...this.sortInfo,
      }).then((res) => {
        if (res.code == "0000") {
          this.pageData.total = res.totalCount;
          this.tableData = res.totalPart.map((v) => {
            return this.transformData(v);
          });
          this.totalObj.ord = "总计";
          this.totalObj = this.transformData(res.collec);
          this.totalObj.appName = "--";
          this.totalObj.osType = "--";
          this.totalObj.popuStatus = "--";
          this.totalObj.latestStatus = "--";
        }
        this.loading = false;
      });
    },
    transformData(obj) {
      let item = JSON.parse(JSON.stringify(obj));
      item.popuStatus = item.popuStatus == 1 ? "是" : "否";
      item.osType = osTypeFu(item.osType);
      for (let child in item.collec) {
        item[child] = item.collec[child];
      }
      item.popTotalUSD = item.popTotalUSD.toFixed(2);

      Object.keys(item).forEach((key) => {
        const findObj = this.columns.find((child) => child.key == key) || {};
        const unitStr =
          (item[key] || item[key] === 0) && findObj.unit ? findObj.unit : "";
        const valueStr = item[key] || item[key] === 0 ? item[key] : "--";
        const percentStr =
          (item[key] || item[key] === 0) && findObj.percent
            ? findObj.percent
            : "";
        item[key] = `${unitStr}${valueStr}${percentStr}`;
      });
      return item;
    },
    downLoadFileToExcel() {
      getAllReportListFetch({
        ...this.filterParams,
        ...this.sortInfo,
        page: 1,
        size: 99999,
      }).then((res) => {
        if (res.code == "0000") {
          let tableData = JSON.parse(JSON.stringify(res.totalPart));
          let totalObj = JSON.parse(JSON.stringify(res.collec));
          tableData = tableData.map((v) => {
            return this.transformData(v);
          });
          totalObj = this.transformData(totalObj);
          totalObj.ord = "总计";
          totalObj.appName = "--";
          totalObj.osType = "--";
          totalObj.popuStatus = "--";
          totalObj.latestStatus = "--";
          const haderData = {};
          const columns = this.columns;
          columns.forEach((item) => {
            haderData[item.key] = item.name;
          });
          this.$emit("closeDownLoadLoading");
          downLoadWrokSheet(
            [totalObj].concat(tableData),
            "总览报表.xlsx",
            haderData
          );
        }
      });
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}
</style>
